import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DeliveryWarehouseStatus as SchemaDeliveryWarehouseStatus } from '../schemas/DeliveryWarehouseStatus';
import { type ProductVariantStocks as SchemaProductVariantStocks } from '../schemas/ProductVariantStocks';
import { type WarehouseStatus as SchemaWarehouseStatus } from '../schemas/WarehouseStatus';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Возвращает склады, соответствующие фильтрам, и остатки указанного варианта товара.
Склады без записи об остатках также возвращаются — с нулевыми значениями количества.
Фильтрация, поиск и пагинация выполняются на бэкенде.

 * @tags Products
 * @summary Получить остатки варианта товара по складам
 */
export const GetProductVariantStocksContentType = '' as const;
export type GetProductVariantStocksRequest = void;
export type GetProductVariantStocksResponses = LinkCommonErrorResponses & {
    /**
     * @description Остатки варианта товара по складам
     */
    '200': {
        'application/json': SchemaProductVariantStocks;
    };
};
export type GetProductVariantStocksResponseSuccess = GetProductVariantStocksResponses['200']['application/json'];
export type GetProductVariantStocksSearchParams = {
    page?: number;
    per_page?: number;
    warehouse_status?: SchemaWarehouseStatus;
    query?: string;
    delivery_status?: SchemaDeliveryWarehouseStatus;
};
export type GetProductVariantStocksPathParameters = {
    product_variant_id: string;
};
export const GetProductVariantStocksUrl = '/variants/{product_variant_id}/stocks' as const;
export const GetProductVariantStocksMethod = 'GET' as const;
export const getGetProductVariantStocksUrl = (params: GetProductVariantStocksPathParameters) =>
    GetProductVariantStocksUrl.replace(/\{(\w+)\}/g, (_match, param: keyof GetProductVariantStocksPathParameters) =>
        String(params[param])
    );
